import { defaultThemeCss } from "./defaultThemeStyle" with { type: "macro" };

export type BuildFile = { path: string; content: string };

// Workflows created before the designs feature was removed have a globals.css
// that `@import "./style.css"` and renders shadcn `.cn-*` components against a
// set of theme variables. The designs feature used to supply both (the style
// pack via this injected file, the variable values via a runtime STYLE_HTML
// injection). With designs gone we bake a fixed default theme here — the shadcn
// component classes plus the neutral light palette they reference — so those
// served pages keep rendering. New (plain-Tailwind) templates don't import
// style.css, so they never receive it.
const defaultThemeStyleCss: BuildFile = {
  path: "style.css",
  content: defaultThemeCss(),
};

export function prepareBuildFiles<T extends BuildFile>(
  files: T[]
): BuildFile[] {
  const codeFiles = files.filter((f) => f.path !== "config.toml");
  const globals = codeFiles.find((f) => f.path === "globals.css");
  if (!globals) return codeFiles;
  if (codeFiles.some((f) => f.path === "style.css")) return codeFiles;
  if (!globals.content.includes("style.css")) return codeFiles;
  return [...codeFiles, defaultThemeStyleCss];
}
